import { createSlice } from "@reduxjs/toolkit";

// Defino valor inicial para el estado de mi slice
const initialState = {
  data: [],
};

// creo el slice con toda su configuración y sus acciones
const deptosSlice = createSlice({
  name: "deptosSlice",
  initialState,
  reducers: {
    setDeptosList: (state, action) => {
      state.data = action.payload;
    },
  },
});

// Expongo las funcionalidades
export const { setDeptosList } = deptosSlice.actions;

export default deptosSlice.reducer;
